<div class="flex-column gap-3">
  <div>{{ 'organization-settings.webGateway.hint' | translate }}</div>
  <div>{{ 'organization-settings.webGateway.saveHint' | translate }}</div>
  <div class="flex flex-wrap gap-2 align-items-start pt-2">
    <app-text-input
      [formField]="newIntegrationForm.name"
      label="organization-settings.webGateway.fields.name"
    ></app-text-input>
    <app-button
      icon="pi-plus"
      severity="success"
      label="organization-settings.webGateway.add"
      (clickEvent)="addIntegration()"
    ></app-button>
  </div>
  @for (integration of formData().integrations; track integration.id; let index = $index) {
    <div class="flex-column gap-2 pt-2">
      <div class="flex flex-wrap gap-2 align-items-center">
        <app-text-input
          [formField]="formDef.integrations[index].name"
          label="organization-settings.webGateway.fields.name"
        ></app-text-input>
        <app-switch-input
          [formField]="formDef.integrations[index].active"
          label="organization-settings.active"
        ></app-switch-input>
        <app-button
          icon="pi-trash"
          severity="danger"
          [text]="true"
          label="organization-settings.webGateway.remove"
          (clickEvent)="removeIntegration(integration.id)"
        ></app-button>
      </div>
      <app-text-input
        class="w-full"
        [value]="formData().tokens[integration.id] ?? ''"
        [readonly]="true"
        label="organization-settings.webGateway.fields.token"
      ></app-text-input>
      <div class="flex flex-wrap gap-2">
        <app-button
          icon="pi-copy"
          [text]="true"
          label="organization-settings.webGateway.copy"
          [disabled]="!formData().tokens[integration.id]"
          (clickEvent)="copyToken(integration.id)"
        ></app-button>
        <app-button
          icon="pi-refresh"
          [text]="true"
          label="organization-settings.webGateway.regenerate"
          (clickEvent)="regenerateToken(integration.id)"
        ></app-button>
      </div>
    </div>
  }
  <div class="align-self-end">
    <app-save-button
      [disabled]="!formDef().dirty() || formDef().invalid()"
      (clickEvent)="saveSettings()"
    ></app-save-button>
  </div>
</div>
